var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Add 'component-header-reduced' class to header if y scroll position is greater than 0 on home page
            $(window).on('scroll', () => {
                if (!$('body').hasClass('section-home'))
                    return;
                if (window.scrollY > 0) {
                    $('.component-header').addClass('component-header-reduced');
                }
                else {
                    $('.component-header').removeClass('component-header-reduced');
                }
            });
            // Sub menus
            $('.component-header menu > a').on('click', (event, link) => {
                event.preventDefault();
                link.parent().find('.btn-toggle-content').trigger('click');
            });
            this.success();
        });
    }
}
